module.exports = __webpack_public_path__ + "static/media/dmQuiz.0dd3c5e8.jpg";